import { frontendURL } from 'dashboard/helper/URLHelper';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import { INSTALLATION_TYPES } from 'dashboard/constants/installationTypes';
import PipelineView from './pages/PipelineView.vue';
import DealDetailShell from './pages/DealDetailShell.vue';
import CommercialReports from './pages/CommercialReports.vue';
import store from 'dashboard/store';
import { isCommercialFeatureEnabled } from 'dashboard/helper/commercialFeatureHelper';

const requireCommercialFeature = feature => to =>
  isCommercialFeatureEnabled({
    accountId: to.params.accountId,
    feature,
    isFeatureEnabled: store.getters['accounts/isFeatureEnabledonAccount'],
  }) || frontendURL(`accounts/${to.params.accountId}/dashboard`);

const meta = {
  featureFlag: FEATURE_FLAGS.BOTZ_CRM_PIPELINE,
  permissions: ['administrator', 'agent'],
  installationTypes: [INSTALLATION_TYPES.CLOUD, INSTALLATION_TYPES.ENTERPRISE],
};

const reportMeta = {
  featureFlag: FEATURE_FLAGS.BOTZ_CRM_REPORTS,
  permissions: ['administrator', 'report_manage'],
  installationTypes: [INSTALLATION_TYPES.CLOUD, INSTALLATION_TYPES.ENTERPRISE],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/deals'),
    name: 'deals_pipeline',
    component: PipelineView,
    meta,
    beforeEnter: requireCommercialFeature(FEATURE_FLAGS.BOTZ_CRM_PIPELINE),
  },
  {
    path: frontendURL('accounts/:accountId/reports/commercial'),
    name: 'commercial_reports',
    component: CommercialReports,
    meta: reportMeta,
    beforeEnter: requireCommercialFeature(FEATURE_FLAGS.BOTZ_CRM_REPORTS),
  },
  {
    path: frontendURL('accounts/:accountId/deals/:dealId'),
    name: 'deal_detail',
    component: DealDetailShell,
    meta,
    beforeEnter: requireCommercialFeature(FEATURE_FLAGS.BOTZ_CRM_PIPELINE),
  },
];
